import Cell from "./Cell";
import CreationManager from "../../managers/CreationManager";
import Utils from "../../utils/Utils";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import { SpineGameObject } from "@esotericsoftware/spine-phaser";
import { LayoutBuilder } from "../buildLayoutTree";

export default class Reel {
    protected scene: any;

    public gameDataManager: any;
    public gameLogicVariableManager: any;

    protected container: Phaser.GameObjects.Container;

    protected index: number = 0;

    public cellPosition: any;
    public reelMask!: Phaser.GameObjects.Graphics;

    protected spinProgress!: Phaser.Tweens.Tween;
    protected bounceTween1: Phaser.Tweens.Tween | undefined;
    protected bounceTween2: Phaser.Tweens.Tween | undefined;

    protected spinProgressValue: { value: number; } = { value: 0 };
    public readonly spinAnimationDuration: number = 50;

    public readonly suspenseDuration: number = 3000;
    protected virtualReelPosition: number = 0;
    protected realMemoIndex: number = 0;
    protected suspense: boolean | undefined;
    protected suspenseStarted: boolean | undefined;

    public canStop: boolean | undefined;
    public mustStop: boolean | undefined;
    public stopped: boolean | undefined;
    public forced: boolean | undefined;
    public mustEnableSuspense: boolean | undefined;
    public mustEnableStop: boolean | undefined;

    public numOfCellsPerReel: any;
    public numOfExtraCellsPerReel : any;
    public lastCellIndex:any;
    public cellSize:any;
    public numOfReels: number;

    public stopEvent: Phaser.Time.TimerEvent | undefined;
    public soundScatterInReel: any;
    public soundReelSuspence: any;

    // public expandingWild!: Cell;
    protected cells: Cell[];

    protected layoutBuilder: LayoutBuilder;

    constructor(scene: any, x: number, y: number, index: number, gameLogicVariableManager: any, gameDataManager: any, orientation: any, layoutBuilder: LayoutBuilder) {
        this.scene = scene;
        this.gameLogicVariableManager = gameLogicVariableManager;
        this.gameDataManager = gameDataManager;

        this.index = index;

        this.numOfCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
        this.numOfExtraCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        this.lastCellIndex = this.numOfCellsPerReel + this.numOfExtraCellsPerReel - 1;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.numOfReels = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS;
        this.layoutBuilder = layoutBuilder;


        this.container = this.layoutBuilder.findByPath(`Basegame/grid/reel_${index}`) as Phaser.GameObjects.Container;

        // Utils.createDebugGraphics(this.scene, 0, 0, 230, 230*5, 0x2314c6,0.2, { x: 0.5, y: 0.5 }, this.container);

        let cellCreation = CreationManager.createCells(this.scene, this.gameLogicVariableManager, this, this.container, this.layoutBuilder);
        this.cells = cellCreation.cells;
        this.cellPosition = cellCreation.cellPositions;

        this.createReelMask(orientation);

        this.soundScatterInReel = ResourcesDispatcher.SOUNDS.SCATTER_IN_REEL;
        this.soundReelSuspence = ResourcesDispatcher.SOUNDS.RULLO_SUSPENSE;
        
        // this.expandingWild = CreationManager.createExpandingWild(this.scene, this.gameLogicVariableManager, ResourcesDispatcher.GAME_CONSTANTS.CELLS_POSITION, 2, this, layoutBuilder);
        // this.container.add(this.expandingWild.getContainer());
    }

    public createReelMask(orientation: any): void {}

    public setIndex(index: number) {
        this.index = index;
    }

    /** PUBLIC GETTERS **/
    public getIndex(): number {
        return this.index;
    }

    public getContainer(): Phaser.GameObjects.Container {
        return this.container;
    }

    public getCell(index: number): Cell {
        return this.cells[index];
    }

    public getCells(): Cell[] {
        return this.cells;
    }
    /*******************/

    public enableSuspense() {
        this.suspense = true;
    }

    public setReelBackgroundSuspense() {
        this.scene.gameArea.turnoOnSuspense(this.index);
    }

    public resetReelBackground() {
        this.scene.gameArea.turnoOffSuspense();
    }

    public resetFlagsAndCounters() {
        this.resetReelBackground();
        this.turnOn();
        this.virtualReelPosition = Utils.getRandomInt(0, this.scene.gameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.stopped = false;
        this.forced = false;
        this.suspense = false;
        this.canStop = false;
        this.mustStop = false;
        this.suspenseStarted = false;
        this.mustEnableSuspense = false;
        this.mustEnableStop = false;
        this.realMemoIndex = 0;

        this.removeStopEvent();
    }

    public turnOn() {
        this.getCells().forEach(c => c.turnOn());
    }

    public turnOff() {
        this.getCells().forEach(c => c.turnOff());
    }

    public resetCellsPositions() {
        return;
        this.getCells().forEach((cell, index) => {
            cell.getContainer().y = (this.cellSize.height * index) - (this.cellSize.height / 2);
        });
    }

    public reIndexCells() {
        let resetCells: Cell[] = [];

        for (let i = 1; i < this.numOfCellsPerReel + this.numOfExtraCellsPerReel; i++) {

            resetCells[i - 1] = this.getCell(i);
            this.getCell(i).setIndex(i - 1);
        }

        this.getCell(0).setIndex(this.lastCellIndex);
        resetCells[this.lastCellIndex] = this.getCell(0);

        this.cells = resetCells;
    }

    public configureSpinTween() {}

    public spin() {
        this.spinProgress.play();
    }

    //TODO Refattorizzare l'animazione del bounce della singola cella

    public playAnimationBounceSingleCell (cell: Cell, memoIndex: number) {
        const anims = cell.getSymbolSpineRaw(memoIndex).animations;
        if (anims && anims.length > 1) {
            const spine = cell.getSpine(memoIndex);
            const track = spine.animationState.addAnimation(Cell.WinAnimationTrack, anims[1], false); // <-- animations[1]
            track.alpha = Cell.WinAnimationAlpha;
            spine.setVisible(true);
            cell.getImage().setVisible(false);

            track.listener = {
                complete: () => {
                    // ripristino come fa playAnimation()
                    spine.setVisible(false);
                    spine.skeleton.setToSetupPose();
                    cell.getImage().setVisible(true);
                }
            };
        }
    };

    protected bounce() {}

    public manageSuspense() {
        
        if (this.suspense && this.suspenseStarted) {
            this.stopReelSuspenseAnimation();
        }

        if (this.mustEnableSuspense && !this.forced) {
            this.scene.gameArea.reels[this.index + 1].startSuspense();
            this.stopEvent = this.scene.time.addEvent({
                delay: this.suspenseDuration,
                callbackScope: this,
                callback: () => {
                    this.scene.gameArea.reels[this.index + 1].canStop = true;
                },
            });
        } else if (this.mustEnableStop && !this.forced) {
            this.stopEvent = this.scene.time.addEvent({
                delay: this.spinAnimationDuration * (this.lastCellIndex),
                callbackScope: this,
                callback: () => {
                    this.scene.gameArea.reels[this.index + 1].canStop = true;
                },
            });
        }

        // if (this.index === this.numOfReels - 1 || this.index === this.scene.gameArea.lastReelWithSuspense) {
        //     // stop scatter that are currently animating, if any
        //     this.scene.gameArea.reels.forEach((reel:any) => {
        //         reel.cells.forEach((_cell:any) => {
                    
        //         });
        //     });
        // }
    }

    public startSuspense() {
        this.setReelBackgroundSuspense();
        this.turnOff();
        this.suspenseStarted = true;
        this.scene.soundManager.play(this.soundReelSuspence);
    }

    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    public securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        } else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        } else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }

    public removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }

        this.stopEvent = undefined;
    }

    public stopReelSuspenseAnimation() { 
        if (this.suspense && this.suspenseStarted) {
            this.suspense = false;
            this.suspenseStarted = false;
            this.resetReelBackground();
            this.turnOn();
        }
    }

    public forceStop() {
        this.canStop = true;
        this.mustStop = true;
        this.forced = true;

        this.getCells().forEach(cell => cell.stopAnimation());

        this.removeStopEvent();

        if (this.suspense && this.suspenseStarted) {
            this.stopReelSuspenseAnimation();
        }

        this.scene.soundManager.stop(this.soundReelSuspence);
    }
}
